import { tns } from 'tiny-slider/src/tiny-slider'
import 'tiny-slider/dist/tiny-slider.css'

const SELECTORS = Selectors({
  element: 'element-imageslidermap'
})

const $element = document.querySelector(SELECTORS.asClass('element'))

const fn = {
  init: () => {
    fn.setupImageSlider()
  },

  setupImageSlider: () => {
    const $slider = $element.querySelector('.image-slider')

    if (!$slider) {
      return
    }

    tns({
      container: '.image-slider',
      items: 1,
      slideBy: 'page',
      nav: false,
      controlsText: ['', '']
    })
  }
}

export default {
  can: () => $element,
  run: fn.init
}
